<template>
  <PvDialog id="addtransactiondialog" v-model:visible="visible" modal :closable="false" :style="{ width: '50%' }" >
    <template #header>
      <div>
        <h2>Create Transaction</h2>
        <p>Please provide general transaction information and click 'Create Transaction'.</p>
      </div>
    </template>
    <AddTransaction ref="addTransactionRef" @dataSaved="handleTransactionSaved" />
    <template #footer>
      <div class="d-flex justify-content-end w-100 my-0">
        <PvButton type="button" label="Create Transaction" @click="handleTransactionSave" rounded raised  />
        <PvButton type="button" class="ms-2" rounded raised @click="() => visible = false" label="Cancel" severity="secondary" />
      </div>
    </template>
  </PvDialog>
</template>
<script setup>
// ===============================
// IMPORTS
// ===============================
// Vue Core
import { ref } from 'vue';

// Components
import AddTransaction from '@/modules/hcet/components/HceAddEditTransaction.vue';

// Composables


// Stores


// Constants and Utils


// ===============================
// PROPS & EMITS
// ===============================

const visible = defineModel('visible', { type: Boolean, required: true });
const emit = defineEmits(['transactionSaved']);

// ===============================
// COMPOSABLES & STORES
// ===============================


// ===============================
// REACTIVE STATE
// ===============================


// ===============================
// CONSTANTS
// ===============================
const addTransactionRef = ref(null);

// ===============================
// COMPUTED PROPERTIES
// ===============================


// ===============================
// METHODS
// ===============================
const handleTransactionSave = () => {
  addTransactionRef.value.onSubmit();
};
const handleTransactionSaved = (transactionId) => {
  emit('transactionSaved', transactionId);
  visible.value = false;
};

// ===============================
// WATCHERS
// ===============================


// ===============================
// LIFECYCLE HOOKS
// ===============================


// ===============================
// EXPOSE
// ===============================


</script>

<style scoped>

</style>